@if (isModule()) {
  <button
    type="button"
    [class]="classesFor(active())"
    (click)="activate.emit()"
    [attr.aria-expanded]="expanded()"
  >
    <span class="flex items-center gap-2.5 overflow-hidden">
      @if (iconPath(); as d) {
        <svg
          class="h-4 w-4 shrink-0"
          [class]="iconClasses(active())"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="d" />
        </svg>
      }
      @if (!collapsed()) {
        <span class="flex-1 truncate text-left">{{ label() }}</span>
      }
    </span>
    @if (!collapsed()) {
      <svg
        class="h-4 w-4 shrink-0 transition-transform"
        [class]="iconClasses(active())"
        [class.rotate-180]="expanded()"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    }
  </button>
} @else if (isSubmodule()) {
  <a [routerLink]="route()" routerLinkActive="" #rla="routerLinkActive" [class]="classesFor(rla.isActive)">
    <span class="truncate">{{ label() }}</span>
  </a>
} @else {
  <a
    [routerLink]="route()"
    routerLinkActive=""
    #rla="routerLinkActive"
    [class]="classesFor(rla.isActive)"
  >
    @if (iconPath(); as d) {
      <svg
        class="h-4 w-4 shrink-0"
        [class]="iconClasses(rla.isActive)"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="d" />
      </svg>
    }
    @if (!collapsed()) {
      <span class="truncate">{{ label() }}</span>
    }
  </a>
}
